import { getSessionStorage } from 'ts/services/Storage';
import { FlowType } from '../../services/userflow/UserFlowService';

const FLOW_KEY = 'passwordlessLoginFlow';

const setFlow = (flow: FlowType): FlowType => {
  getSessionStorage().setItem(FLOW_KEY, flow);
  return flow;
};

const getFlow = (): FlowType => {
  const flowStr = getSessionStorage().getItem(FLOW_KEY);
  const flow = flowStr as FlowType;
  return flow;
};

export { setFlow, getFlow };
